import React, { FunctionComponent, ReactNode } from "react";
import { Button, Dialog, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FileObject } from "../FileDropzone/typings/FileObject.type";
import { PictureDropzone2 } from "../../components/Pickers/picture-dropzone.component(2)";

interface OwnProps {
  imageUpload: boolean;
  logoPath: string;
  logoFile: FileObject[] | undefined;
  setImageUpload: React.Dispatch<React.SetStateAction<boolean>>;
  setLogoPath: React.Dispatch<React.SetStateAction<string>>;
  setLogoFile: React.Dispatch<React.SetStateAction<FileObject[] | undefined>>;
}

type Props = OwnProps;

const LogoUploadDialog: FunctionComponent<Props> = ({
  imageUpload,
  logoFile,
  logoPath,
  setImageUpload,
  setLogoFile,
  setLogoPath
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={() => setImageUpload(false)}
      aria-label={"simple-dialog-title"}
      aria-labelledby="simple-dialog-title"
      open={imageUpload}
    >
      <DialogContent
        style={{ display: "flex", justifyContent: "flex-end", flexDirection: "column" }}
      >
        <PictureDropzone2
          title={t("Company logo upload")}
          files={logoFile ?? []}
          current={logoPath ?? undefined}
          error={!logoFile}
          helperText={logoFile as ReactNode}
          handleClose={() => setImageUpload(false)}
          onAdd={files => {
            setLogoFile(files);
            setLogoPath("temp");
          }}
          onDelete={() => {
            setLogoFile(undefined);
            setLogoPath("");
          }}
        />
        <Button
          onClick={() => setImageUpload(false)}
          disabled={!logoFile}
          data-testid={"close"}
          color={"primary"}
        >
          {t("Confirm")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default LogoUploadDialog;
